<template>
<Dialog header="   " 
v-model:visible="$store.state.evaluation.show_correction_request_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
:closable="true"
>

<div class="flex align-items-center justify-content-center mb-6 flex-column">

<h2 class="text-green-400 text-center">
{{$store.state.languages.lang_phrases.goruntulediginiz_asama_icin_duzeltme_talebi_gondermek_uzeresiniz}}
</h2>


</div>

<Textarea maxlength="140" type="text" v-model="reason" class="w-full p-inputtext-sm animate_class" rows="8" :placeholder="$store.state.languages.lang_phrases.devam_etmek_icin_lutfen_duzeltme_talep_sebebinizi_kisaca_belirtin" />
<small class="text-red-500" v-show="reason_length>140">{{$store.state.languages.lang_phrases.max_karakter}} 140</small>

<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.devam_et" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="$store.state.ui.submitting"/>
</template>



</Dialog>
</template>

<script>
export default {

  name: 'CorrectionRequestModal',

  data () {
    return {
    	reason:"",
    	submitting:false,
    }
  },
  computed:{
  	reason_length()
  	{
  		return this.reason.length
  	}
  },
  methods:{
  	close()
  	{
      //console.log("close")
  		this.$store.dispatch('evaluation/setShowCorrectionRequestModal',false) 
  	},
  	async submit()
  	{

  		if(this.reason==="" || !this.reason)
  		{
  			this.showMessage("error","",this.$store.state.languages.lang_phrases.lutfen_bu_alani_doldurun)
  			return false
  		}
  		let formdata = new FormData()
  		formdata.append("reason",this.reason)
  		this.generalSubmission(formdata,"audit/request_correction/"+this.$route.params.id,this.afterSubmit)
  	},
  	async afterSubmit(response)
  	{
      this.$store.dispatch('evaluation/setShowCorrectionRequestModal',false) 
  		this.showMessage("success","",this.$store.state.languages.lang_phrases.duzeltme_talebiniz_iletildi)
  		let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
  		this.$router.push({ name: 'SupplierBrandProject',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid} })
  		
  	},
  }
}
</script>

<style lang="css" scoped>
</style>